import { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaFilePdf, FaMoneyBill, FaMoneyBillWave, FaPlus, FaPrint, FaSearch, FaUserFriends, FaUserTie, FaHandHoldingUsd, FaChartLine } from 'react-icons/fa';
import { MdDelete, MdEdit, MdClose } from 'react-icons/md';
import styles from "./pagos.module.css";
import { api } from '../../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../../utils/constants/services';
import Swal from 'sweetalert2';
import WindowLayout from '../../utils/layout/windowsLayout';
import Select from 'react-select';
import { FaMessage, FaTableList } from 'react-icons/fa6';
import { FaEllipsisV, FaEdit, FaTrash, FaEye } from 'react-icons/fa';
import { Modal } from 'react-bootstrap';
import { DatePicker } from 'antd';
import 'antd/dist/reset.css';
import dayjs from 'dayjs';
import { downloadPDFFromBase64, isMobileDevice, openPDFInNewWindow } from '../../utils/downloadUtils';
import Amortizacion from '../prestamos/amortizacion';
import { IoPersonAddSharp, IoWarning } from 'react-icons/io5';

// Función utilitaria para obtener la fecha actual en formato local YYYY-MM-DD
const getCurrentDateLocal = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate())
        .toLocaleDateString('es-MX', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            timeZone: 'America/Mexico_City'
        }).split('/').reverse().join('-');
};

const conditionalRowStyles = [
        {
            when: row => row.typeClient === "EMP",
            style: {
                backgroundColor: '#f8f9ff',
                borderLeft: '4px solid #6f42c1',
                '&:hover': {
                    backgroundColor: '#e7e8ff',
                    cursor: 'pointer',
                },
            },
        },
        {
            when: row => row.typeClient === "CLT",
            style: {
                borderLeft: '4px solid #ffffffff',
            },
        },
    ];


const customStyles = {
    headRow: {
        style: {
            minHeight: "40px",
            backgroundColor: "#046cc2",
            fontSize: "15px",
            color: "white",
        },
    },


};
export default function Pagos(props) {
    const { windowSize, clientActual, userId, setMenuActual, permisos } = useAuth();
    const { clientId } = props

    const [showModal, setShowModal] = useState(false);
    const [showAmor, setShowAmor] = useState(false);
    const [showAmorT, setShowAmorT] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [fecha, setFecha] = useState(new Date().toLocaleDateString('es-MX', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'America/Mexico_City'
    }).split('/').reverse().join('-'));
    const [userEdit, setUserEdit] = useState(null);
    const [ofices, setOfices] = useState([]);
    const { estados, municipios, codigos } = useAuth();
    const [genders, setGenders] = useState([]);

    const [loadingTable, setLoadingTable] = useState(false);
    const [totalRows, setTotalRows] = useState(10);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(50);
    const [textSearch, setTextSearch] = useState("");

    const [textSearchPrev, setTextSearchPrev] = useState("");

    const [asesorSelect, setAsesorSelect] = useState(null);
    const [asesores, setAsesores] = useState([]);

    const [asesorLocked, setAsesorLocked] = useState(false);

    const [clientSelect, setClientSelect] = useState(null);
    const [clients, setClients] = useState([]);
    const [clientsAll, setClientsAll] = useState([]);
    const [clientsSelect, setClientsSelect] = useState(null);
    const [prestamoActual, setPrestamoActual] = useState(null);
    const [estatusAll, setEstatusAll] = useState([{
        value: 1,
        label: "Asignado"
    },
    {
        value: 2,
        label: "Por asignar"
    }]);
    const [estatusSelect, setEstatusSelect] = useState("PEN");
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [loadingPrint2, setLoadingPrint2] = useState(false);
    const [loadingPrint3, setLoadingPrint3] = useState(false);
    const [showCommentModal, setShowCommentModal] = useState(false);
    const [selectedComment, setSelectedComment] = useState({ message: '', date: '', id: 0 });
    const [fines, setFines] = useState([]);
    const [fineAmount, setFineAmount] = useState("");
    const [fineDate, setFineDate] = useState(getCurrentDateLocal());
    const [editingFineId, setEditingFineId] = useState(null);
    const [paymentTotals, setPaymentTotals] = useState({
        montoPagadoDiario: 0,
        montoPendienteDiario: 0,
        montoCobranzaDiaria: 0,
        montoAportacionesAsesor: 0,
        montoDeudaReal: 0,
        montoVencidos: 0
    });
    const [statusFilter, setStatusFilter] = useState(0); // 0: Todos, 1: En tiempo, 2: Vencidos
    const [showStatusFilter, setShowStatusFilter] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 120, left: 20 });
    const dropdownTimeout = useRef(null);
    const statusHeaderRef = useRef(null);

    useEffect(() => {
        if (showStatusFilter) {
            
            const handleClickOutside = (event) => {
                if (!event.target.closest('.status-filter-dropdown') && 
                    !event.target.closest('.status-dropdown-menu')) {
                    setShowStatusFilter(false);
                }
            };

            document.addEventListener('mousedown', handleClickOutside);
            
            return () => {
                clearTimeout(dropdownTimeout.current);
                document.removeEventListener('mousedown', handleClickOutside);
            };
        } else {
            if (dropdownTimeout.current) {
                clearTimeout(dropdownTimeout.current);
            }
        }
    }, [showStatusFilter]);

    const handleShowCommentModal = (row) => {
        setSelectedComment({
            message: row.comments || '',
            date: row.dateComments || 'Fecha no disponible.',
            id: row.amortizationTableId || 0
        });
        // Cargar fines asociados a esta amortización
        fetchFines(row.amortizationTableId);
        setFineAmount("");
        setFineDate(getCurrentDateLocal());
        setEditingFineId(null);
        setShowCommentModal(true);
    };

    const handleCloseCommentModal = () => {
        setShowCommentModal(false);
    };


    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    const columns = [
        {
            name: '#',
            selector: row => row.number,
            sortable: true,
            width: '60px',
        },
        ...(estatusSelect === "PEN"
            ? [
                {
                    name: 'Acciones',
                    cell: (row) => {
                        if (estatusSelect === "PAG") {
                            return (
                                <div style={{ display: "flex" }}>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-primary position-relative"
                                        onClick={() => handleShowCommentModal(row)}
                                    >
                                        <FaMessage />
                                        {row.comments !== null ? (
                                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                                !
                                                <span className="visually-hidden">unread messages</span>
                                            </span>
                                        ) : null}
                                    </button>
                                </div>
                            );
                        } else {
                            return (
                                <>
                                    <div style={{ display: "flex", gap: "5px" }}>
                                        <button
                                            className="btn btn-sm btn-success"
                                            onClick={() => {
                                                handlePagoUnico(row);
                                            }}
                                        >
                                            <FaMoneyBillWave /> Pagar
                                        </button>
                                        {!row.haveAdvisorContribution && row.typeClient!="EMP" && (
                                            <button
                                                className="btn btn-sm btn-info"
                                                onClick={() => {
                                                    handleAportacionUnica(row);
                                                }}
                                                title="Agregar aportación del asesor"
                                            >
                                                <IoPersonAddSharp /> Aportar
                                            </button>
                                        )}
                                    </div> &nbsp;
                                    <button
                                        className='btn btn-sm btn-primary'
                                        onClick={() => {
                                            setPrestamoActual({
                                                id: row.loanId,
                                                typeClient:  row.typeClient,
                                                advisorName: row.advisorName,
                                            });
                                            setShowAmor(true);
                                        }}
                                        title="Ver amortización"
                                    >
                                        <FaTableList />
                                    </button>
                                </>

                            );
                        }
                    },
                    width: "280px",
                },
            ]
            : []),
        {
            name: 'Comentarios',
            cell: (row) => {
                if (row.comments === null || row.comments === "") {
                    return (
                        <button type="button" class="btn btn-sm btn-primary position-relative"
                            onClick={() => handleShowCommentModal(row)}>
                            <FaMessage />


                        </button>
                    )
                }
                else {
                    return (
                        <div className={styles.coment} onClick={() => handleShowCommentModal(row)}>
                            {row.comments ? row.comments : ""}
                        </div>
                    )
                }


            },
            width: '140px',
        },
        {
            name: (
                <div 
                    ref={statusHeaderRef}
                    className="status-filter-dropdown" 
                    style={{ position: 'relative', display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                    onClick={(e) => {
                        e.stopPropagation();
                        const rect = e.currentTarget.getBoundingClientRect();
                        setDropdownPosition({
                            top: rect.bottom + 5,
                            left: rect.left
                        });
                        setShowStatusFilter(!showStatusFilter);
                    }}
                >
                    <span>
                        Estatus<br></br> {statusFilter === 1 ? '(En tiempo)' : statusFilter === 2 ? '(Vencidos)' : ''}
                    </span>
                </div>
            ),
            selector: row => {
                const currentDate = new Date(fecha);
                currentDate.setHours(0, 0, 0, 0);
                const amortizationDate = new Date(row.amortizationDate);
                amortizationDate.setHours(0, 0, 0, 0);

                if (estatusSelect === "PAG") {
                    return Infinity; // Los pagos realizados se ordenan al final
                } else if (amortizationDate < currentDate) {
                    const diffTime = Math.abs(currentDate - amortizationDate);
                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Calcular días de diferencia
                    return -diffDays; // Los días vencidos se devuelven como negativos para ordenar correctamente
                } else {
                    return 0; // Los pagos en tiempo se ordenan en el medio
                }
            },
            cell: (row) => {


                if (estatusSelect === "PAG") {
                    return (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span className="badge bg-success">PAGADO</span>
                        </div>
                    );
                }

                // Función helper para crear fechas sin zona horaria
                const createDateOnly = (dateString) => {
                    const [year, month, day] = dateString.split('-');
                    return new Date(year, month - 1, day);
                };

                const currentDate = createDateOnly(fecha);
                const amortizationDate = createDateOnly(row.amortizationDate.split('T')[0]);

                if (amortizationDate < currentDate) {
                    const diffTime = Math.abs(currentDate - amortizationDate);
                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                    return (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span className="badge bg-danger">
                                VENCIDO ({diffDays} {diffDays === 1 ? "día" : "días"})
                            </span>
                        </div>
                    );
                } else {
                    return (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span className="badge bg-success">EN TIEMPO</span>
                        </div>
                    );
                }
            },
            sortable: true,
            width: '150px',
        },
        {
            name: 'Cliente',
               cell: (row) => (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {row.typeClient === "EMP" && (
                                    <FaUserTie 
                                        style={{ 
                                            color: '#6f42c1', 
                                            fontSize: '16px',
                                            flexShrink: 0
                                        }} 
                                        title="Empleado"
                                    />
                                )}
                                <span style={{ wordBreak: 'break-word' }}>
                                    {row.clientName}
                                </span>
                            </div>
                        ),
            wrap: true,
            sortable: true,
            width: '200px',
        },
        {
            name: '',
            wrap: true,
            sortable: true,
            width: '30px',
            cell: (row) => (
                <div>
                    {
                        (
                            row.haveAdvisorContribution ? (<IoPersonAddSharp
                                style={{
                                    color: '#2844a7ff',
                                    marginRight: '5px',
                                    fontSize: '20px'
                                }}
                                title="Pago con aportación del asesor"
                            />) : null
                        )
                    }
                </div>
            ),
        },
        {
            name: 'Asesor',
            selector: row => row.advisorName,
            wrap: true,
            sortable: true,
            width: '200px',
            cell: (row) => (
                <div>
                    {row.advisorName}
                </div>
            ),
        },
        {
            name: 'Coordinador',
            selector: row => row.coordinatorName,
            wrap: true,
            sortable: true,
            width: '200px',
        },
        {
            name: '# Pago',
            selector: row => row.amortizationNumber,
            sortable: true,
            width: '130px',
        },
        {
            name: 'Fecha Inicio',
            selector: row => row.startDate ? row.startDate.split("T")[0] : "-",
            sortable: true,
            width: '140px',
        },
        {
            name: 'Fecha Pago',
            selector: row => row.amortizationDate ? row.amortizationDate.split("T")[0] : "-",
            sortable: true,
            width: '140px',
        },

        ...(estatusSelect === "PAG"
            ? [
                {
                    name: 'Fecha Pago',
                    selector: row => row.paymentDate ? row.paymentDate.split("T")[0] : "-",
                    sortable: true,
                    width: '140px',
                },
            ]
            : []),
        {
            name: 'Monto',
            selector: row => estatusSelect === "PAG" ? 
            `$ ${row.paymentAmount.toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}` : `$ ${row.amortizationAmount.toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`,
            sortable: true,
        },
        {
            name: 'Pendiente',
            selector: row => `$ ${row.amountPending.toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`,
            sortable: true,
            width: '140px',
        },
        {
            name: 'Multas',
            selector: row => `$ ${Number(row.finesTotal || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
            sortable: true,
            width: '140px',
        },


    ];
    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const handleClearRows = () => {
        setToggleCleared(!toggleCleared);
        setSelectedRows([]);
    };
    const handleGetAsesortes = () => {
        api(SERVICE.getAsesoresAll)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.completeName
                        });
                    }
                }
                setAsesores(arrayTemp);
                handleGetInfoUser(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetInfoUser = (asesoresTemp) => {
        api(SERVICE.getUserById + userId)
            .then((data) => {
                if (data.data.data) {
                    let dataUser = data.data.data;
                    if (dataUser.advisorId === null || dataUser.advisorId === 0) {
                        setAsesorLocked(false);
                    }
                    else {
                        let findIndex = asesoresTemp.find(a => a.value === dataUser.advisorId);
                        if (findIndex) {
                            setAsesorSelect(findIndex);
                            setAsesorLocked(true);
                        }
                    }

                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetClients = (asesorId) => {
        let URL = SERVICE.getClientsAdvisor;
        if(asesorId){
            URL += `?AdvisorId=${asesorId}`;
        }
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            ...element,
                            value: element.id,
                            label: element.clientName
                        });

                    }
                }
                setClients(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const handleUpdate = () => {
        setLoadingPrint2(false);
        setSelectedRows([]);
        setToggleCleared(!toggleCleared);
        setLoadingTable(true);
        let URL = SERVICE.getPayment + `?TypeSearch=1&Page=${page}&PageSize=${perPage}&date=${fecha}&type=${estatusSelect}&status=${statusFilter}${clientSelect ? "&clientId=" + clientSelect.value : ""}${asesorSelect ? "&advisorId=" + asesorSelect.value : ""}`;
        if (textSearch != "") {
            URL = URL + `&TextSearch=${textSearch}`;
        }
        setTextSearchPrev(textSearch);
        setTextSearch("");
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if (data && data.data && data.data.paginationInfo) {
                    setTotalRows(data.data.paginationInfo.totalRecords);
                }
                if (data.data.data) {
                    // Almacenar los totales
                    setPaymentTotals({
                        montoPagadoDiario: data.data.data.montoPagadoDiario || 0,
                        montoPendienteDiario: data.data.data.montoPendienteDiario || 0,
                        montoCobranzaDiaria: data.data.data.montoCobranzaDiaria || 0,
                        montoAportacionesAsesor: data.data.data.montoAportacionesAsesor || 0,
                        montoDeudaReal: data.data.data.montoDeudaReal || 0,
                        montoVencidos: data.data.data.montoVencidos || 0
                    });

                    for (let index = 0; index < data.data.data.listPayments.length; index++) {
                        const element = data.data.data.listPayments[index];
                        arrayTemp.push({ ...element, number: ((page - 1) * perPage) + (index + 1) });
                    }
                    // Obtener multas por amortization y anexarlas
                    const finesPromises = arrayTemp.map(item => api(SERVICE.getByAmortizationTableId + item.amortizationTableId).catch(() => null));
                    Promise.all(finesPromises).then(results => {
                        const updated = arrayTemp.map((item, i) => {
                            const res = results[i];
                            const fines = (res && res.data && res.data.data) ? res.data.data : [];
                            const finesTotal = fines.reduce((s, f) => s + (Number(f.amount || 0)), 0);
                            return { ...item, fines: fines, finesTotal };
                        });
                        setDataTable(updated);
                    }).catch((err) => {
                        console.log('Error fetching fines for pagos', err);
                        setDataTable(arrayTemp);
                    });
                } else {
                    setDataTable(arrayTemp);
                }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setLoadingTable(false);
            })
    }
    const handleUpdateNosearch = () => {
        setLoadingPrint2(false);
        setSelectedRows([]);
        setToggleCleared(!toggleCleared);
        setLoadingTable(true);
        let URL = SERVICE.getPayment + `?TypeSearch=1&Page=${page}&PageSize=${perPage}&date=${fecha}&type=${estatusSelect}&status=${statusFilter}`;

        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if (data && data.data && data.data.paginationInfo) {
                    setTotalRows(data.data.paginationInfo.totalRecords);
                }
                if (data.data.data) {
                    // Almacenar los totales
                    setPaymentTotals({
                        montoPagadoDiario: data.data.data.montoPagadoDiario || 0,
                        montoPendienteDiario: data.data.data.montoPendienteDiario || 0,
                        montoCobranzaDiaria: data.data.data.montoCobranzaDiaria || 0,
                        montoAportacionesAsesor: data.data.data.montoAportacionesAsesor || 0,
                        montoDeudaReal: data.data.data.montoDeudaReal || 0,
                        montoVencidos: data.data.data.montoVencidos || 0
                    });

                    for (let index = 0; index < data.data.data.listPayments.length; index++) {
                        const element = data.data.data.listPayments[index];
                        arrayTemp.push({ ...element, number: ((page - 1) * perPage) + (index + 1) });
                    }
                    const finesPromises = arrayTemp.map(item => api(SERVICE.getByAmortizationTableId + item.amortizationTableId).catch(() => null));
                    Promise.all(finesPromises).then(results => {
                        const updated = arrayTemp.map((item, i) => {
                            const res = results[i];
                            const fines = (res && res.data && res.data.data) ? res.data.data : [];
                            const finesTotal = fines.reduce((s, f) => s + (Number(f.amount || 0)), 0);
                            return { ...item, fines: fines, finesTotal };
                        });
                        setDataTable(updated);
                    }).catch((err) => {
                        console.log('Error fetching fines for pagos', err);
                        setDataTable(arrayTemp);
                    });
                } else {
                    setDataTable(arrayTemp);
                }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setLoadingTable(false);
            })
    }
    const handlePagoUnico = (element) => {
        let maxAmount = 0;
        if (element.amountPending > 0) {
            maxAmount = element.amountPending;
        }
        else {
            maxAmount = element.amortizationAmount;
        }

        // Verificar si el usuario tiene el permiso para aplicar cualquier fecha
        const hasApplyAnyDatePermission = permisos.findIndex(item => item.identifier === "ApplyAnyDate") !== -1;

        if (hasApplyAnyDatePermission) {
            // Mostrar modal para seleccionar fecha y monto
            Swal.fire({
                title: 'Registrar Pago',
                html: `
                    <div style="text-align: left; margin-bottom: 15px;">
                        <p><strong>Monto máximo:</strong> $${maxAmount.toLocaleString('es-MX', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}</p>
                    </div>
                    <input id="amount-input" class="swal2-input" type="number" 
                           placeholder="Ingrese el monto a pagar" 
                           min="0.01" 
                           max="${maxAmount}" 
                           step="0.01"
                           value="${maxAmount}"
                           style="margin-bottom: 10px;">
                    <input id="payment-date" class="swal2-input" type="date" 
                           value="${getCurrentDateLocal()}"
                           style="margin: 0;">
                `,
                showCancelButton: true,
                confirmButtonText: "PAGAR",
                confirmButtonColor: "#079459",
                cancelButtonText: "CANCELAR",
                preConfirm: () => {
                    const amount = parseFloat(document.getElementById('amount-input').value);
                    const selectedDate = document.getElementById('payment-date').value;

                    if (!amount || isNaN(amount)) {
                        Swal.showValidationMessage('Por favor ingrese un monto válido');
                        return false;
                    }

                    if (amount <= 0) {
                        Swal.showValidationMessage('El monto debe ser mayor que cero');
                        return false;
                    }

                    if (amount > maxAmount) {
                        Swal.showValidationMessage(`El monto no puede ser mayor que $${maxAmount.toLocaleString('es-MX', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}`);
                        return false;
                    }

                    if (!selectedDate) {
                        Swal.showValidationMessage('Por favor seleccione una fecha válida');
                        return false;
                    }

                    return { amount, date: selectedDate };
                }
            }).then((result) => {
                if (result.isConfirmed && result.value) {
                    const { amount, date } = result.value;
                    procesarPago(element, amount, date);
                }
            });
        } else {
            // Mostrar modal para seleccionar solo monto (fecha actual)
            Swal.fire({
                title: 'Registrar Pago',
                html: `
                    <div style="text-align: left; margin-bottom: 15px;">
                        <p><strong>Monto máximo:</strong> $${maxAmount.toLocaleString('es-MX', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}</p>
                    </div>
                    <input id="amount-input" class="swal2-input" type="number" 
                           placeholder="Ingrese el monto a pagar" 
                           min="0.01" 
                           max="${maxAmount}" 
                           step="0.01"
                           value="${maxAmount}"
                           style="margin: 0;">
                `,
                showCancelButton: true,
                confirmButtonText: "PAGAR",
                confirmButtonColor: "#079459",
                cancelButtonText: "CANCELAR",
                preConfirm: () => {
                    const amount = parseFloat(document.getElementById('amount-input').value);

                    if (!amount || isNaN(amount)) {
                        Swal.showValidationMessage('Por favor ingrese un monto válido');
                        return false;
                    }

                    if (amount <= 0) {
                        Swal.showValidationMessage('El monto debe ser mayor que cero');
                        return false;
                    }

                    if (amount > maxAmount) {
                        Swal.showValidationMessage(`El monto no puede ser mayor que $${maxAmount.toLocaleString('es-MX', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}`);
                        return false;
                    }

                    return amount;
                }
            }).then((result) => {
                if (result.isConfirmed && result.value) {
                    const paymentAmount = result.value;
                    procesarPago(element, paymentAmount, getCurrentDateLocal());
                }
            });
        }
    };

    const procesarPago = (element, paymentAmount, paymentDate) => {
        setLoadingPrint2(true);
        let payload = [];

        const fechaCompare = element.amortizationDate.split('T')[0]; // "2025-01-15"
        const fechaPago = paymentDate; // Fecha seleccionada o actual

        let tipoPago = "";
        if (fechaCompare < fechaPago) {
            tipoPago = "PAGATR";
        }
        else if (fechaCompare > fechaPago) {
            tipoPago = "PAGADE";
        }
        else {
            tipoPago = "PAG";
        }
        
        // Si el monto pendiente es diferente al monto de amortización original, es un abono
        if ((element.amountPending !== element.amortizationAmount) && element.amountPending > 0) {
            if(fechaCompare < fechaPago){
                tipoPago = "PAGABONATR";
            }
            else{
                tipoPago = "PAGABON";
            }
            
        }
        
        // Si el monto a pagar es menor que el monto máximo disponible, también es un abono
        const maxAmount = element.amountPending > 0 ? element.amountPending : element.amortizationAmount;
        if (paymentAmount < maxAmount) {
            if(fechaCompare < fechaPago){
                tipoPago = "PAGABONATR";
            }
            else{
                tipoPago = "PAGABON";
            }
        }
        
        payload.push(
            {
                "TypePaymentIdentifier": tipoPago,
                "AmortizationTableId": element.amortizationTableId,
                "Amount": paymentAmount,
                "Date": fechaPago,
                "UserId": userId,
            }
        );
        api(SERVICE.setPago, payload, "POST")
            .then((data) => {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Pago realizado correctamente",
                    showConfirmButton: false,
                    timer: 1500
                });
                handleUpdate();
            })
            .catch((err) => {
                console.log(err);
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: "Error al procesar el pago",
                    text: "Inténtalo de nuevo",
                    showConfirmButton: true
                });
            })
            .finally(() => {
                setLoadingPrint2(false);
                setSelectedRows([]);
                setToggleCleared(!toggleCleared);
            })
    }
    const handleAportacionUnica = (element) => {
        let total = 0;
        if (element.amountPending > 0) {
            total += element.amountPending;
        }
        else {
            total += element.amortizationAmount;
        }

        // Verificar si el usuario tiene el permiso para aplicar cualquier fecha
        const hasApplyAnyDatePermission = permisos.findIndex(item => item.identifier === "ApplyAnyDate") !== -1;

        if (hasApplyAnyDatePermission) {
            // Mostrar modal para seleccionar fecha
            Swal.fire({
                title: 'Seleccionar Fecha de Aportación',
                html: `
                    <div style="text-align: left; margin-bottom: 15px;">
                        <p><strong>Monto a aportar:</strong> $${total.toLocaleString('es-MX', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}</p>
                    </div>
                    <input id="contribution-date" class="swal2-input" type="date" 
                           value="${getCurrentDateLocal()}"
                           style="margin: 0;">
                `,
                showCancelButton: true,
                confirmButtonText: "APORTAR",
                confirmButtonColor: "#072594ff",
                cancelButtonText: "CANCELAR",
                preConfirm: () => {
                    const selectedDate = document.getElementById('contribution-date').value;
                    if (!selectedDate) {
                        Swal.showValidationMessage('Por favor seleccione una fecha válida');
                        return false;
                    }
                    return selectedDate;
                }
            }).then((result) => {
                if (result.isConfirmed && result.value) {
                    const contributionDate = result.value;
                    procesarAportacion(element, total, contributionDate);
                }
            });
        } else {
            // Proceder con la confirmación normal usando la fecha actual
            Swal.fire({
                title: "<div>Se realizará <b>1</b> aportación por la cantidad de <b style='color:green'>$ " + total.toLocaleString('es-MX', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }) + "</b></div>",
                showCancelButton: true,
                confirmButtonText: "APORTAR",
                confirmButtonColor: "#072594ff",
                cancelButtonText: "CANCELAR"
            }).then((result) => {
                if (result.isConfirmed) {
                    procesarAportacion(element, total, getCurrentDateLocal());
                }
            });
        }
    };

    const procesarAportacion = (element, total, contributionDate) => {
        setLoadingPrint2(true);
        let payload = {
            "LoanId": element.loanId,
            "Date": contributionDate,
            "Amount": element.amountPending > 0 ? element.amountPending : element.amortizationAmount,
            "Details": [{
                "AmortizationTableId": element.amortizationTableId,
                "Amount": element.amountPending > 0 ? element.amountPending : element.amortizationAmount
            }]
        };

        api(SERVICE.setAportacion, payload, "POST")
            .then((data) => {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Aporte realizado correctamente",
                    showConfirmButton: false,
                    timer: 1500
                });
                handleUpdate();
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setLoadingPrint2(false);
                setSelectedRows([]);
                setToggleCleared(!toggleCleared);
            })
    }
    const handlePagoUnicoParcial = (element) => {
        let maxAmount = 0;
        if (element.amountPending > 0) {
            maxAmount = element.amountPending;
        }
        else {
            maxAmount = element.amortizationAmount;
        }

        Swal.fire({
            title: 'Registrar Pago',
            html: `
                <div style="text-align: left; margin-bottom: 15px;">
                    <p><strong>Monto máximo:</strong> $${maxAmount.toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</p>
                </div>
                <input id="amount-input" class="swal2-input" type="number" 
                       placeholder="Ingrese el monto a pagar" 
                       min="0.01" 
                       max="${maxAmount}" 
                       step="0.01"
                       value="${maxAmount}"
                       style="margin: 0;">
            `,
            showCancelButton: true,
            confirmButtonText: "PAGAR",
            confirmButtonColor: "#079459",
            cancelButtonText: "CANCELAR",
            preConfirm: () => {
                const amount = parseFloat(document.getElementById('amount-input').value);

                if (!amount || isNaN(amount)) {
                    Swal.showValidationMessage('Por favor ingrese un monto válido');
                    return false;
                }

                if (amount <= 0) {
                    Swal.showValidationMessage('El monto debe ser mayor que cero');
                    return false;
                }

                if (amount > maxAmount) {
                    Swal.showValidationMessage(`El monto no puede ser mayor que $${maxAmount.toLocaleString('es-MX', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}`);
                    return false;
                }

                return amount;
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                const paymentAmount = result.value;

                Swal.fire({
                    title: `<div>Se realizará <b>1</b> pago por la cantidad de <b style='color:green'>$ ${paymentAmount.toLocaleString('es-MX', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}</b></div>`,
                    showCancelButton: true,
                    confirmButtonText: "CONFIRMAR PAGO",
                    confirmButtonColor: "#079459",
                    cancelButtonText: "CANCELAR"
                }).then((confirmResult) => {
                    if (confirmResult.isConfirmed) {
                        setLoadingPrint2(true);
                        let payload = [];

                        const fechaCompare = element.amortizationDate.split('T')[0];
                        const hoy = getCurrentDateLocal();

                        let tipoPago = "";
                        if (fechaCompare < hoy) {
                            tipoPago = "PAGATR";
                        }
                        else if (fechaCompare > hoy) {
                            tipoPago = "PAGADE";
                        }
                        else {
                            tipoPago = "PAG";
                        }
                        if ((element.amountPending !== element.amortizationAmount) && element.amountPending > 0) {
                            tipoPago = "PAGABON";
                        }

                        if (paymentAmount < maxAmount) {
                            tipoPago = "PAGABON";
                        }

                        payload.push(
                            {
                                "TypePaymentIdentifier": tipoPago,
                                "AmortizationTableId": element.amortizationTableId,
                                "Amount": paymentAmount,
                                "Date": getCurrentDateLocal(),
                                "UserId": userId,
                            }
                        );
                        api(SERVICE.setPago, payload, "POST")
                            .then((data) => {
                                Swal.fire({
                                    position: "center",
                                    icon: "success",
                                    title: "Pago realizado correctamente",
                                    showConfirmButton: false,
                                    timer: 1500
                                });
                                handleUpdate();
                            })
                            .catch((err) => {
                                console.log(err);
                                Swal.fire({
                                    position: "center",
                                    icon: "error",
                                    title: "Error al procesar el pago",
                                    text: "Inténtalo de nuevo",
                                    showConfirmButton: true
                                });
                            })
                            .finally(() => {
                                setLoadingPrint2(false);
                                setSelectedRows([]);
                                setToggleCleared(!toggleCleared);
                            })
                    }
                });
            }
        });
    }

    const handleUpdateComent = () => {
        if (selectedComment.id !== 0) {
            let URL = SERVICE.setCommentsPago + `?Id=${selectedComment.id}&Comments=${selectedComment.message}`
            api(URL, {}, "PUT")
                .then((data) => {
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "Comentario guardado correctamente",
                        showConfirmButton: false,
                        timer: 1500
                    });
                    handleUpdate();
                    handleCloseCommentModal();
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                })
        }
    }
    // FINES: obtener, crear, editar, eliminar
    const fetchFines = (amortizationTableId) => {
        if (!amortizationTableId) {
            setFines([]);
            return;
        }
        api(SERVICE.getByAmortizationTableId + amortizationTableId)
            .then((data) => {
                if (data && data.data && data.data.data) {
                    setFines(data.data.data);
                } else {
                    setFines([]);
                }
            })
            .catch((err) => {
                console.log(err);
                setFines([]);
            })
    }

    const handleSaveFine = () => {
        if (!selectedComment.id) return;
        const amount = parseFloat(fineAmount);
        if (!amount || isNaN(amount) || amount <= 0) {
            Swal.fire({ icon: 'warning', title: 'Ingresa un monto válido', showConfirmButton: true });
            return;
        }
        const payload = editingFineId ? {
            Id: editingFineId,
            AmortizationTableId: selectedComment.id,
            Amount: amount,
            Date: fineDate
        } : {
            AmortizationTableId: selectedComment.id,
            Amount: amount,
            Date: fineDate
        };

        const method = editingFineId ? 'PUT' : 'POST';
        const url = editingFineId ? SERVICE.updateFiner : SERVICE.setFiner;

        api(url, payload, method)
            .then((data) => {
                Swal.fire({ position: 'center', icon: 'success', title: editingFineId ? 'Multa actualizada' : 'Multa registrada', showConfirmButton: false, timer: 1500 });
                fetchFines(selectedComment.id);
                setFineAmount("");
                setFineDate(getCurrentDateLocal());
                setEditingFineId(null);
            })
            .catch((err) => {
                console.log(err);
                Swal.fire({ position: 'center', icon: 'error', title: 'Error al guardar la multa', showConfirmButton: true });
            })
    }

    const handleEditFine = (fine) => {
        setEditingFineId(fine.id);
        setFineAmount(fine.amount);
        setFineDate(fine.date ? fine.date.split('T')[0] : getCurrentDateLocal());
    }

    const handleDeleteFine = (id) => {
        Swal.fire({
            title: '¿Eliminar falta?',
            text: 'Esta acción no se puede deshacer',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                api(SERVICE.DeleteFiner + `?Id=${id}`, {}, 'DELETE')
                    .then(() => {
                        Swal.fire({ position: 'center', icon: 'success', title: 'Falta eliminada', showConfirmButton: false, timer: 1200 });
                        fetchFines(selectedComment.id);
                    })
                    .catch((err) => {
                        console.log(err);
                        Swal.fire({ position: 'center', icon: 'error', title: 'Error al eliminar la falta', showConfirmButton: true });
                    })
            }
        })
    }
    const handleDownload = () => {
        if (fecha !== "" && fecha !== null && asesorSelect !== null) {
            setLoadingPrint3(true);

            api(SERVICE.reportPagos + `?date=${fecha}&advisorId=${asesorSelect.value}`)
                .then((data) => {
                    if (data.data.data) {
                        const info = data.data.data;
                        const fileName = asesorSelect.label + "_" + fecha + ".pdf";

                        const success = downloadPDFFromBase64(info, fileName);

                        if (!success && isMobileDevice()) {
                            openPDFInNewWindow(info);
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Error al descargar el reporte",
                        text: "Inténtalo de nuevo",
                        showConfirmButton: true
                    });
                })
                .finally(() => {
                    setLoadingPrint3(false);
                })
        }
    }
    const handleDownload2 = () => {
        if (fecha !== "" && fecha !== null && asesorSelect !== null) {
            setLoadingPrint3(true);

            api(SERVICE.getReportPDFClientsNRN + `?advisorId=${asesorSelect.value}`)
                .then((data) => {
                    if (data.data.data) {
                        const info = data.data.data;
                        const fileName = asesorSelect.label + "_" + fecha + ".pdf";

                        const success = downloadPDFFromBase64(info, fileName);

                        if (!success && isMobileDevice()) {
                            openPDFInNewWindow(info);
                        }
                    }
                    else {
                        Swal.fire({
                            position: "center",
                            icon: "info",
                            title: "No hay información para generar el reporte",
                            showConfirmButton: true
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Error al descargar el reporte",
                        text: "Inténtalo de nuevo",
                        showConfirmButton: true
                    });
                })
                .finally(() => {
                    setLoadingPrint3(false);
                })
        }
    }
    const handleAddPayment = () => {
        if (selectedRows.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Selecciona al menos un pago para registrar.',
                showConfirmButton: true,
            });
            return;
        }
        else {
            let total = 0;
            for (let index = 0; index < selectedRows.length; index++) {
                const element = selectedRows[index];
                if (element.amountPending > 0) {
                    total += element.amountPending;
                }
                else {
                    total += element.amortizationAmount;
                }
            }
            let textMesage = "Se realizarán <b>" + selectedRows.length + "</b> pagos";
            if (selectedRows.length === 1) {
                textMesage = "Se realizará <b>" + selectedRows.length + "</b> pago";
            }

            // Verificar si el usuario tiene el permiso para aplicar cualquier fecha
            const hasApplyAnyDatePermission = permisos.findIndex(item => item.identifier === "ApplyAnyDate") !== -1;

            if (hasApplyAnyDatePermission) {
                // Mostrar modal para seleccionar fecha
                Swal.fire({
                    title: 'Seleccionar Fecha de Pago',
                    html: `
                        <div style="text-align: left; margin-bottom: 15px;">
                            <p><strong>Número de pagos:</strong> ${selectedRows.length}</p>
                            <p><strong>Monto total:</strong> $${total.toLocaleString('es-MX', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}</p>
                        </div>
                        <input id="payment-date-multiple" class="swal2-input" type="date" 
                               value="${getCurrentDateLocal()}"
                               style="margin: 0;">
                    `,
                    showCancelButton: true,
                    confirmButtonText: "PAGAR",
                    confirmButtonColor: "#079459",
                    cancelButtonText: "CANCELAR",
                    preConfirm: () => {
                        const selectedDate = document.getElementById('payment-date-multiple').value;
                        if (!selectedDate) {
                            Swal.showValidationMessage('Por favor seleccione una fecha válida');
                            return false;
                        }
                        return selectedDate;
                    }
                }).then((result) => {
                    if (result.isConfirmed && result.value) {
                        const paymentDate = result.value;
                        procesarPagosMultiples(selectedRows, total, textMesage, paymentDate);
                    }
                });
            } else {
                // Proceder con la confirmación normal usando la fecha actual
                Swal.fire({
                    title: "<div>" + textMesage + " por la cantidad de <b style='color:green'>$ " + total.toLocaleString('es-MX', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) + "</b></div>",
                    showCancelButton: true,
                    confirmButtonText: "PAGAR",
                    confirmButtonColor: "#079459",
                    cancelButtonText: "CANCELAR"
                }).then((result) => {
                    if (result.isConfirmed) {
                        procesarPagosMultiples(selectedRows, total, textMesage, getCurrentDateLocal());
                    }
                });
            }
        }
    };

    const procesarPagosMultiples = (rows, total, textMesage, paymentDate) => {
        setLoadingPrint2(true);
        let payload = [];

        for (let index = 0; index < rows.length; index++) {
            const element = rows[index];

            const fechaCompare = element.amortizationDate.split('T')[0];
            const fechaPago = paymentDate; // Fecha seleccionada o actual

            let tipoPago = "";
            if (fechaCompare < fechaPago) {
                tipoPago = "PAGATR";
            }
            else if (fechaCompare > fechaPago) {
                tipoPago = "PAGADE";
            }
            else {
                tipoPago = "PAG";
            }
            if ((element.amountPending !== element.amortizationAmount) && element.amountPending > 0) {
                tipoPago = "PAGABON";
            }
            payload.push(
                {
                    "TypePaymentIdentifier": tipoPago,
                    "AmortizationTableId": element.amortizationTableId,
                    "Amount": element.amountPending > 0 ? element.amountPending : element.amortizationAmount,
                    "Date": fechaPago,
                    "UserId": userId,
                }
            );
        }
        api(SERVICE.setPago, payload, "POST")
            .then((data) => {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Pagos realizados correctamente",
                    showConfirmButton: false,
                    timer: 1500
                });
                handleUpdate();
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setLoadingPrint2(false);
                setSelectedRows([]);
                setToggleCleared(!toggleCleared);
            })
    }

    useEffect(() => {
        handleGetAsesortes();

    }, [])
    useEffect(() => {
        handleGetClients(asesorSelect ? asesorSelect.value : null);
    }, [asesorSelect])
    useEffect(() => {
        if (asesores.length > 0 && clients.length > 0) {
            handleUpdate();
        }
    }, [page, perPage, estatusSelect, fecha, clientSelect, asesorSelect, asesores, clients, statusFilter])
    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePerRowsChange = (newPerPage) => {
        setPerPage(newPerPage);
    };
    const contextActions = useMemo(() => {
        const handleDelete = () => {
            if (window.confirm(`¿Estás seguro de querer eliminar:\r ${selectedRows.map(r => r.folio).join(', ')}?`)) {
                setToggleCleared(!toggleCleared);
                // Aquí puedes agregar la lógica para eliminar los registros seleccionados
            }
        };

        return (
            <div className={styles.contextActions}>
                <button key="delete" onClick={handleDelete} className="btn btn-danger btn-sm">
                    <MdDelete /> Eliminar seleccionados
                </button>
                <button key="clear" onClick={handleClearRows} className="btn btn-secondary btn-sm ms-2">
                    <MdClose /> Limpiar selección
                </button>
            </div>
        );
    }, [selectedRows, toggleCleared]);
    useEffect(() => {
        console.log("selectedRows", selectedRows)
    }, [selectedRows])
    return (
        <>
            {/* Estilos CSS para animaciones del dropdown */}
            <style jsx>{`
                @keyframes dropdownSlideIn {
                    from {
                        opacity: 0;
                        transform: translateY(-10px) scale(0.95);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0) scale(1);
                    }
                }
            `}</style>

            <WindowLayout
                title="Pagos"
                route={["Inicio", "Pagos"]}
                actions={[() => setMenuActual("homeMenu")]}
                icon={<FaMoneyBill />}
            >

                <div style={{ display: "flex", justifyContent: "left", alignItems: "center", flexWrap: "wrap" }}>
                    <div className={styles.itemForm} style={{ zIndex: 7 }}>
                        <label class="form-label">Asesor: </label>
                        <Select isDisabled={asesorLocked} isClearable options={asesores} class="form-control" placeholder="Asesor" value={asesorSelect} onChange={(e) => setAsesorSelect(e)} />
                    </div>
                    <div className={styles.itemForm} style={{ zIndex: 6 }}>
                        <label class="form-label">Cliente: </label>
                        <Select isClearable options={clients} class="form-control" placeholder="Cliente" value={clientSelect} onChange={(e) => setClientSelect(e)} />
                    </div>
                    <div className={styles.itemForm}>
                        <label className="form-label">Fecha:</label>
                        <input type="date" class="form-control" placeholder="Fecha" value={fecha} onChange={(e) => setFecha(e.target.value)} />
                    </div>
                </div>

                {/* Sección de Totales */}
                <div className={styles.totalsSection}>
                    <div className={styles.totalCard}>
                        <div className={styles.totalIcon} style={{ backgroundColor: '#17a2b8' }}>
                            <FaMoneyBillWave />
                        </div>
                        <div className={styles.totalInfo}>
                            <h3>${paymentTotals.montoCobranzaDiaria.toLocaleString('es-MX', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}</h3>
                            <p>Monto Cobranza Diario</p>
                        </div>
                    </div>

                    <div className={styles.totalCard}>
                        <div className={styles.totalIcon} style={{ backgroundColor: '#28a745' }}>
                            <FaMoneyBill />
                        </div>
                        <div className={styles.totalInfo}>
                            <h3>${paymentTotals.montoPagadoDiario.toLocaleString('es-MX', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}</h3>
                            <p>Monto Pagado Diario</p>
                        </div>
                    </div>

                    <div className={styles.totalCard}>
                        <div className={styles.totalIcon} style={{ backgroundColor: paymentTotals.montoPendienteDiario > 0 ? '#ffc107' : '#17a2b8' }}>
                            <FaUserFriends />
                        </div>
                        <div className={styles.totalInfo}>
                            <h3 style={{ color: paymentTotals.montoPendienteDiario >= 0 ? '#dc3545' : '#17a2b8' }}>
                                ${Math.abs(paymentTotals.montoPendienteDiario).toLocaleString('es-MX', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}
                            </h3>
                            <p>{paymentTotals.montoPendienteDiario >= 0 ? 'Monto Pendiente Diario' : 'Déficit'}</p>
                        </div>
                    </div>

                    <div className={styles.totalCard}>
                        <div className={styles.totalIcon} style={{ backgroundColor: '#6f42c1' }}>
                            <FaHandHoldingUsd />
                        </div>
                        <div className={styles.totalInfo}>
                            <h3>${paymentTotals.montoAportacionesAsesor.toLocaleString('es-MX', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}</h3>
                            <p>Aportaciones Asesor</p>
                        </div>
                    </div>

                    <div className={styles.totalCard}>
                        <div className={styles.totalIcon} style={{ backgroundColor: '#fd7e14' }}>
                            <FaChartLine />
                        </div>
                        <div className={styles.totalInfo}>
                            <h3>${paymentTotals.montoDeudaReal.toLocaleString('es-MX', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}</h3>
                            <p>Deuda Real</p>
                        </div>
                    </div>

                    <div className={styles.totalCard}>
                        <div className={styles.totalIcon} style={{ backgroundColor: '#dc3545' }}>
                            <FaMoneyBill />
                        </div>
                        <div className={styles.totalInfo}>
                            <h3>${paymentTotals.montoVencidos.toLocaleString('es-MX', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}</h3>
                            <p>Monto Vencidos</p>
                        </div>
                    </div>
                </div>

                {/* Contador de registros */}
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    padding: '10px 0', 
                    borderBottom: '1px solid #dee2e6',
                    marginBottom: '10px'
                }}>
                    <div style={{ 
                        fontSize: '14px', 
                        fontWeight: 'bold', 
                        color: '#6c757d',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                       
                        <span>Total de registros: {totalRows.toLocaleString('es-MX')}</span>
                        {statusFilter !== 0 && (
                            <span style={{ 
                                color: '#007bff',
                                fontSize: '12px',
                                fontStyle: 'italic'
                            }}>
                                (Filtrado por: {statusFilter === 1 ? 'En tiempo' : 'Vencidos'})
                            </span>
                        )}
                    </div>
                </div>

                <div className={styles.containerTabs} style={{ display: "flex", justifyContent: "space-between" }}>
                    <div className={styles.tabs}>
                        <ul class="nav nav-tabs">
                            <li className={estatusSelect === "PEN" ? "nav-item-active" : "nav-item"} onClick={() => setEstatusSelect("PEN")}>
                                <a className={estatusSelect === "PEN" ? "nav-link active" : "nav-link"}>Pendientes</a>
                            </li>
                            <li className={estatusSelect === "PAG" ? "nav-item-active" : "nav-item"} onClick={() => setEstatusSelect("PAG")}>
                                <a className={estatusSelect === "PAG" ? "nav-link active" : "nav-link"}>Pagados</a>
                            </li>
                        </ul>
                    </div>
                    <div className={styles.actions}>

                        <button className='btn btn-primary' style={{ marginRight: "10px" }} onClick={() => handleDownload()} disabled={loadingPrint3 || asesorSelect == null}>
                            {loadingPrint3 ? <div class="spinner-border text-ligth spinner-border-sm" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div> : <>
                                <FaPrint />
                            </>}
                        </button>
                        <button className='btn btn-warning' style={{ marginRight: "10px" }} onClick={() => handleDownload2()} disabled={loadingPrint3 || asesorSelect == null}>
                            {loadingPrint3 ? <div class="spinner-border text-ligth spinner-border-sm" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div> : <>
                                <FaPrint /> Clientes sin renovar
                            </>}
                        </button>
                        <button className='btn btn-success' style={{ marginRight: "10px" }} onClick={() => handleAddPayment()} disabled={selectedRows.length === 0 || loadingPrint2}>
                            {loadingPrint2 ? "Generando..." : <>
                                <FaMoneyBillWave /> Registrar pagos
                            </>}
                        </button>
                    </div>
                </div>
                <div class="input-group flex-nowrap" style={{ marginBottom: "10px", width: "500px", display: "none" }}>
                    <input type="text" class="form-control" placeholder="Busqueda" value={textSearch} onChange={(e) => setTextSearch(e.target.value)} aria-describedby="addon-wrapping" />
                    <button className='btn btn-primary' onClick={handleUpdate}><FaSearch /></button>
                </div>
                <div class="input-group flex-nowrap containerSearchPrev" style={{ display: textSearchPrev !== "" ? "flex" : "none" }}>
                    <div class="badgeSearch">Buscando por: <b>{textSearchPrev}</b> </div><div onClick={() => {
                        setTextSearch("");
                        setTextSearchPrev("");
                        handleUpdateNosearch();
                    }} className='divCloseSearch'><MdClose></MdClose></div>
                </div>
                {
                    estatusSelect === "PEN" ?
                        <DataTable
                            columns={columns}
                            data={dataTable}
                            conditionalRowStyles={conditionalRowStyles}
                            customStyles={APP_OPTIONS.TABLE_SETTING}
                            pagination
                            paginationServer
                            paginationTotalRows={totalRows}
                            paginationPerPage={perPage}
                            paginationRowsPerPageOptions={[50, 70, 100, 150, 200]}
                            onChangePage={handlePageChange}
                            onChangeRowsPerPage={handlePerRowsChange}
                            progressPending={loadingTable}
                            persistTableHead
                            fixedHeader
                            fixedHeaderScrollHeight="65%"
                            highlightOnHover

                            responsive

                            selectableRows
                            selectableRowsHighlight
                            onSelectedRowsChange={handleRowSelected}
                            contextActions={contextActions}
                            clearSelectedRows={toggleCleared}
                            noDataComponent="No se encontraron registros"
                        />
                        :
                        <DataTable
                            columns={columns}
                            data={dataTable}
                            conditionalRowStyles={conditionalRowStyles}
                            customStyles={APP_OPTIONS.TABLE_SETTING}
                            pagination
                            paginationServer
                            paginationTotalRows={totalRows}
                            paginationPerPage={perPage}
                            paginationRowsPerPageOptions={[50, 70, 100, 150, 200]}
                            onChangePage={handlePageChange}
                            onChangeRowsPerPage={handlePerRowsChange}
                            progressPending={loadingTable}
                            persistTableHead
                            fixedHeader
                            fixedHeaderScrollHeight="65%"
                            highlightOnHover

                            responsive


                            noDataComponent="No se encontraron registros"
                        />
                }

                {/* Dropdown flotante para filtro de status - Diseño mejorado */}
                {showStatusFilter && (
                    <div 
                        className="status-dropdown-menu"
                        style={{
                            position: 'fixed',
                            top: `${dropdownPosition.top}px`,
                            left: `${dropdownPosition.left}px`,
                            backgroundColor: 'white',
                            border: 'none',
                            borderRadius: '12px',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.12), 0 2px 6px rgba(0,0,0,0.08)',
                            zIndex: 10000,
                            minWidth: '160px',
                            overflow: 'hidden',
                            backdropFilter: 'blur(8px)',
                            animation: 'dropdownSlideIn 0.2s ease-out'
                        }}
                    >
                        {/* Header del dropdown */}
                        <div style={{
                            padding: '12px 16px 8px 16px',
                            backgroundColor: '#f8f9fa',
                            borderBottom: '1px solid #e9ecef',
                            fontSize: '11px',
                            fontWeight: '600',
                            color: '#6c757d',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                        }}>
                            Filtrar por Estatus
                        </div>

                        {/* Opción Todos */}
                        <div 
                            style={{ 
                                padding: '12px 16px', 
                                cursor: 'pointer',
                                backgroundColor: statusFilter === 0 ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'white',
                                fontSize: '13px',
                                color: statusFilter === 0 ? 'white' : '#495057',
                                fontWeight: statusFilter === 0 ? '600' : '500',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                transition: 'all 0.2s ease',
                                borderLeft: statusFilter === 0 ? '4px solid #667eea' : '4px solid transparent'
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setStatusFilter(0);
                                setShowStatusFilter(false);
                            }}
                            onMouseEnter={(e) => {
                                if (statusFilter !== 0) {
                                    e.target.style.backgroundColor = '#f8f9fa';
                                    e.target.style.borderLeft = '4px solid #dee2e6';
                                    e.target.style.transform = 'translateX(2px)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (statusFilter !== 0) {
                                    e.target.style.backgroundColor = 'white';
                                    e.target.style.borderLeft = '4px solid transparent';
                                    e.target.style.transform = 'translateX(0)';
                                }
                            }}
                        >
                            <span style={{ fontSize: '16px' }}>🔍</span>
                            <span>Todos los pagos</span>
                            {statusFilter === 0 && <span style={{ marginLeft: 'auto', fontSize: '14px' }}>✓</span>}
                        </div>

                        {/* Opción En tiempo */}
                        <div 
                            style={{ 
                                padding: '12px 16px', 
                                cursor: 'pointer',
                                backgroundColor: statusFilter === 1 ? 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' : 'white',
                                fontSize: '13px',
                                color: statusFilter === 1 ? 'white' : '#495057',
                                fontWeight: statusFilter === 1 ? '600' : '500',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                transition: 'all 0.2s ease',
                                borderLeft: statusFilter === 1 ? '4px solid #28a745' : '4px solid transparent'
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setStatusFilter(1);
                                setShowStatusFilter(false);
                            }}
                            onMouseEnter={(e) => {
                                if (statusFilter !== 1) {
                                    e.target.style.backgroundColor = '#f8f9fa';
                                    e.target.style.borderLeft = '4px solid #dee2e6';
                                    e.target.style.transform = 'translateX(2px)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (statusFilter !== 1) {
                                    e.target.style.backgroundColor = 'white';
                                    e.target.style.borderLeft = '4px solid transparent';
                                    e.target.style.transform = 'translateX(0)';
                                }
                            }}
                        >
                            <span style={{ fontSize: '16px' }}>✅</span>
                            <span>En tiempo</span>
                            {statusFilter === 1 && <span style={{ marginLeft: 'auto', fontSize: '14px' }}>✓</span>}
                        </div>

                        {/* Opción Vencidos */}
                        <div 
                            style={{ 
                                padding: '12px 16px', 
                                cursor: 'pointer',
                                backgroundColor: statusFilter === 2 ? 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)' : 'white',
                                fontSize: '13px',
                                color: statusFilter === 2 ? 'white' : '#495057',
                                fontWeight: statusFilter === 2 ? '600' : '500',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                transition: 'all 0.2s ease',
                                borderLeft: statusFilter === 2 ? '4px solid #dc3545' : '4px solid transparent',
                                borderRadius: '0 0 12px 12px'
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setStatusFilter(2);
                                setShowStatusFilter(false);
                            }}
                            onMouseEnter={(e) => {
                                if (statusFilter !== 2) {
                                    e.target.style.backgroundColor = '#f8f9fa';
                                    e.target.style.borderLeft = '4px solid #dee2e6';
                                    e.target.style.transform = 'translateX(2px)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (statusFilter !== 2) {
                                    e.target.style.backgroundColor = 'white';
                                    e.target.style.borderLeft = '4px solid transparent';
                                    e.target.style.transform = 'translateX(0)';
                                }
                            }}
                        >
                            <span style={{ fontSize: '20px', color: '#dc3545', marginTop: '-4px' }}><IoWarning /></span>
                            <span>Vencidos</span>
                            {statusFilter === 2 && <span style={{ marginLeft: 'auto', fontSize: '14px' }}>✓</span>}
                        </div>
                    </div>
                )}

            </WindowLayout>
            <Modal size='lg' show={showCommentModal} onHide={handleCloseCommentModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Comentarios</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={styles.containerFormModal}>

                        <div className={styles.itemForm} style={{ width: "100%" }}>
                            <label className="form-label">Fecha:</label>
                            <input
                                disabled
                                type="text"
                                className="form-control"
                                placeholder="Fecha Inicio"
                                value={selectedComment.date.split("T")[0] + " " + selectedComment.date.split("T")[1]?.split(".")[0]}
                            />
                        </div>
                        <div className={styles.itemForm} style={{ width: "100%" }}>
                            <label className="form-label">Comentario:</label>
                            <textarea
                                className="form-control"
                                value={selectedComment.message}
                                rows={5}
                                onChange={(e) => setSelectedComment({
                                    ...selectedComment,
                                    message: e.target.value // Actualizar el mensaje en el estado
                                })}
                            />
                        </div>
                        {/* Sección para gestionar fines (multas) */}
                        <div style={{ width: '100%', marginTop: '12px' }}>
                            <hr />
                            <h5>Multas</h5>
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                                <div className={styles.itemForm} style={{ flex: 1, minWidth: '180px' }}>
                                    <label className="form-label">Monto:</label>
                                    <input type="number" className="form-control" value={fineAmount} onChange={(e) => setFineAmount(e.target.value)} min="0.01" step="0.01" />
                                </div>
                                <div className={styles.itemForm} style={{ width: '220px' }}>
                                    <label className="form-label">Fecha:</label>
                                    <input type="date" className="form-control" value={fineDate} onChange={(e) => setFineDate(e.target.value)} />
                                </div>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <button className="btn btn-primary" onClick={handleSaveFine}>{editingFineId ? 'Actualizar' : 'Agregar'}</button>
                                    {editingFineId && <button className="btn btn-secondary" onClick={() => { setEditingFineId(null); setFineAmount(''); setFineDate(getCurrentDateLocal()); }}>Cancelar</button>}
                                </div>
                            </div>
                            <div style={{ marginTop: '12px' }}>
                                {fines.length === 0 ? <div className="text-muted">No hay multas registradas.</div> : (
                                    <ul className="list-group">
                                        {fines.map(f => (
                                            <li className="list-group-item d-flex justify-content-between align-items-center" key={f.id}>
                                                <div>
                                                    <div><strong>${Number(f.amount).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></div>
                                                    <div className="text-muted" style={{ fontSize: '12px' }}>{f.date ? f.date.split('T')[0] : ''}</div>
                                                </div>
                                                <div style={{ display: 'flex', gap: '6px' }}>
                                                    <button className="btn btn-sm btn-outline-primary" onClick={() => handleEditFine(f)}><FaEdit /></button>
                                                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteFine(f.id)}><FaTrash /></button>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-success" onClick={handleUpdateComent}>
                        Guardar
                    </button>
                </Modal.Footer>
            </Modal>
            <Amortizacion
                show={showAmor}
                setShow={setShowAmor}
                showT={showAmorT}
                setShowT={setShowAmorT}
                prestamoActual={prestamoActual}
                setPrestamoActual={setPrestamoActual}
                handleUpdate={handleUpdate}
            />
        </>
    );
}